/* eslint-disable prettier/prettier */
import React from 'react';
import { Button } from '@arco-design/web-react';
import { IconPhone } from '@arco-design/web-react/icon';
import TextInputController from './Room/TextInputController';
import ToolBar from './Room/ToolBar';
import VolumeIndicator from '@/components/VolumeIndicator';
import styles from './BottomControls.module.less';

interface BottomControlsProps {
  mode: 'entry' | 'room';
  pushToTalkMode?: boolean;
  isHoldingTalkButton?: boolean;
  setIsHoldingTalkButton?: (holding: boolean) => void;
  onStart?: () => void;
  isAITalking?: boolean;
  onInterrupt?: () => void;
  volume?: number;
  isVolumeVisible?: boolean;
  isMuted?: boolean;
}

/**
 * 统一的底部控件组件
 *
 * 完全自包含，所有子元素作为一个整体：
 * - Entry 模式：开始通话按钮
 * - Room 模式：音量指示 + 打断按钮 + 输入框 + 工具栏
 *
 * 位置由父容器控制，可通过 --bottom-controls-offset 变量调整距离底部的距离
 */
export default function BottomControls(props: BottomControlsProps) {
  const {
    mode,
    pushToTalkMode,
    isHoldingTalkButton,
    setIsHoldingTalkButton,
    onStart,
    isAITalking,
    onInterrupt,
    volume = 0,
    isVolumeVisible = true,
    isMuted = false,
  } = props;

  // Entry 模式：只显示开始按钮
  if (mode === 'entry') {
    return (
      <div className={styles.container}>
        <Button
          type="primary"
          shape="round"
          icon={<IconPhone style={{ fontSize: '28px' }} />}
          onClick={onStart}
          className={styles.startButton}
        />
      </div>
    );
  }

  // Room 模式：完整控件
  return (
    <div className={styles.container}>
      {/* 打断按钮 */}
      <div className={`${styles.interruptWrapper} ${isAITalking ? styles.visible : ''}`}>
        <Button
          size="small"
          type="text"
          onClick={onInterrupt}
          className={styles.interruptButton}
        >
          打断AI说话
        </Button>
      </div>

      {/* 音量指示器 */}
      <VolumeIndicator
        volume={volume}
        mode="absolute"
        label={isMuted ? '麦克风已静音' : '说话音量'}
        avatarBased={false}
        visible={isVolumeVisible}
        isMuted={isMuted}
        inline
      />

      {/* 输入框 + 工具栏 */}
      <div className={styles.inputRow}>
        <TextInputController />
        <ToolBar
          pushToTalkMode={pushToTalkMode}
          isHoldingTalkButton={isHoldingTalkButton}
          setIsHoldingTalkButton={setIsHoldingTalkButton}
        />
      </div>
    </div>
  );
}
